/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import MachineryOwnerContainer from './machinery-owner/container/MachineryOwnerContainer';
import MachinerySettingsRoutes from './settings/MachinerySettingsRoutes';
import MachineryApplicationContainer from './machinery-application/container/MachineryApplicationContainer';

function MachineryContainer({ match, pathName }) {
  const permissions = getJson('permissions');
  return (
    <React.Fragment>
      <div className="card-content-listing px-0">
        <div className="container-fluid">
          <div className="row custom-nav-links">
            <ul className="nav nav-tabs tab-container">
              {Acl(permissions, ['VIEW E2E RPT MACHINERY APPLICATIONS']) && (
                <li className="nav-item">
                  <Link
                    to="/rpt/machinery/applications"
                    className={`nav-link per-tab ${
                      pathName.indexOf('rpt/machinery/applications') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Applications
                  </Link>
                </li>
              )}
              {Acl(permissions, ['VIEW E2E RPT MACHINERY OWNERS']) && (
                <li className="nav-item">
                  <Link
                    to="/rpt/machinery/machinery-owner"
                    className={`nav-link per-tab ${
                      pathName.indexOf('rpt/machinery/machinery-owner') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Machinery Owners
                  </Link>
                </li>
              )}
              {Acl(permissions, ['E2E RPT MACHINERY SETTINGS']) && (
                <li className="nav-item">
                  <Link
                    to="/rpt/machinery/machinery-settings"
                    className={`nav-link per-tab ${
                      pathName.indexOf('rpt/machinery/machinery-settings') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Settings
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
        <Switch>
          {Acl(permissions, ['VIEW E2E RPT MACHINERY APPLICATIONS']) && (
            <Route
              exact
              path={`${match.path}`}
              render={() => <Redirect to={`${match.path}/applications`} />}
            />
          )}
          {Acl(permissions, ['VIEW E2E RPT MACHINERY APPLICATIONS']) && (
            <Route
              path={`${match.path}/applications`}
              component={MachineryApplicationContainer}
            />
          )}
          {Acl(permissions, ['VIEW E2E RPT MACHINERY OWNERS']) && (
            <Route
              path={`${match.path}/machinery-owner`}
              component={MachineryOwnerContainer}
            />
          )}
          {Acl(permissions, ['E2E RPT MACHINERY SETTINGS']) && (
            <Route
              path={`${match.path}/machinery-settings`}
              component={MachinerySettingsRoutes}
            />
          )}
        </Switch>
      </div>
    </React.Fragment>
  );
}

MachineryContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(MachineryContainer);
